import React from 'react';
import { SlideContent } from '../components/canvas/SlideContent';
import { SlideFooter } from '../components/canvas/SlideFooter';
import { SlideLogo } from '../components/canvas/SlideLogo';
import { NudgeableGroup } from '../components/canvas/NudgeableGroup';

/**
 * Clean Minimal layout — corporate/startup style.
 * Small logo top-left, left-aligned text, short accent line.
 * Footer pinned at bottom for cross-template consistency.
 */
export function CleanMinimalLayout({ data, fontPreset, logoEnabled = true, logoUrl = null, logoSize = null, logoIsDark = false, pc }) {
  const accentLine = (
    <div className="mt-6 mb-4">
      <div className="w-[120px] h-[4px] rounded-full" style={{ backgroundColor: pc.accent(0.60) }} />
    </div>
  );

  return (
    <div className="absolute inset-0 flex flex-col">
      {/* Top bar — small logo */}
      {logoEnabled && (
        <NudgeableGroup groupId="logo" className="px-[80px] pt-[72px]">
          <SlideLogo className="h-14 w-14" style={{ color: pc.text(0.60) }} logoUrl={logoUrl} size={logoSize} isDark={logoIsDark} />
        </NudgeableGroup>
      )}

      <div className="flex-1 min-h-[60px]" />

      {/* Content */}
      <NudgeableGroup groupId="content" className="px-[80px]">
        <SlideContent
          data={data}
          fontPreset={fontPreset}
          pc={pc}
          options={{
            showFooter: false,
            afterTitle: accentLine,
            mutedOpacity: 0.60,
            subtleOpacity: 0.45,
          }}
        />
      </NudgeableGroup>

      <div className="flex-1 min-h-[100px]" />

      {/* Footer — pinned at bottom */}
      <div className="absolute bottom-[64px] left-[64px] right-[64px]">
        <SlideFooter data={data} pc={pc} />
      </div>
    </div>
  );
}
